import { PhonePriority, PhoneType } from "@app/modules/policySpace/common/policyConstants";
import { ApplicationTrackerStatus } from "@app/modules/tracking/constants";
import { ProductType } from "@app/modules/policySpace/common/policyConstants";

export const defaultTrackerConfig: TrackerDefinition = {
    timeFormat: "HH:mm",
    isEnabled: false,
};

export enum TrackingContactType {
    Agent = "TCT_AGENT",
    Support = "TCT_SUPPORT",
}

export type TrackingPhone = {
    phoneType: PhoneType;
    phoneNumber?: string;
    countryCode?: string;
    extension?: string;
    prioritySequence?: PhonePriority;
};

export type TrackingContact = {
    contactType: TrackingContactType;
    firstName?: string;
    lastName?: string;
    email?: string;
    phones?: TrackingPhone[];
};

export type TrackingActivity = {
    statusChangeDate?: string;
    status?: string;
};

export type TrackingStatusHistory = {
    statusChangeDate?: string;
    status?: ApplicationTrackerStatus;
};

export interface TrackingDetails {
    applicationNumber: string;
    applicationStatus?: ApplicationTrackerStatus;
    policyNumber?: string;
    effectiveDate?: string;
    statusHistories?: TrackingStatusHistory[];
    activityLogs?: TrackingActivity[];
    contacts?: TrackingContact[];
    productType?: ProductType;
    hasAccessApplication?: boolean;
    hasAccessPolicy?: boolean;
}
